// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'cr... Remove this comment to see the full error message
import { createAction } from 'flux-actions';
import keyMirror from 'react-utils/keyMirror';
import { mapPayloadTo } from '../utils';
export const SecurityPhoneNumberActionTypes = keyMirror({
  FETCH_CONFIGURATION: null,
  FETCH_CONFIGURATION_SUCCESSFUL: null,
  FETCH_CONFIGURATION_FAILED: null,
  SETUP_FROM_LOGIN: null,
  SKIP_SETUP: null,
  CLICKED_SETUP: null,
  COMPLETED_SETUP: null,
  CANCELLED_SETUP: null,
  CONFIRMED_SETUP: null,
  CHANGE_SMS_NUMBER: null,
  CONFIGURE_SMS: null,
  CONFIGURE_SMS_REQUEST: null,
  CONFIGURE_SMS_SUCCESS: null,
  CONFIGURE_SMS_FAILURE: null,
  RESEND_CODE: null,
  RESEND_CODE_FAILURE: null,
  CODE_ATTEMPT: null,
  CODE_ATTEMPT_REQUEST: null,
  CODE_ATTEMPT_SUCCESS: null,
  CODE_ATTEMPT_FAILURE: null,
  CHANGED_CODE_ATTEMPT: null
});
export const fetchConfiguration = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION);
export const fetchConfigurationSuccessful = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL, mapPayloadTo('securityPhoneNumber'));
export const fetchConfigurationFailed = createAction(SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_FAILED);
export const setupFromLogin = createAction(SecurityPhoneNumberActionTypes.SETUP_FROM_LOGIN, mapPayloadTo('redirectUrl'));
export const skipSetup = createAction(SecurityPhoneNumberActionTypes.SKIP_SETUP);
export const setup = createAction(SecurityPhoneNumberActionTypes.CLICKED_SETUP);
export const resendCode = createAction(SecurityPhoneNumberActionTypes.RESEND_CODE, mapPayloadTo('phoneNumber'));
export const changeSmsNumber = createAction(SecurityPhoneNumberActionTypes.CHANGE_SMS_NUMBER, mapPayloadTo('phoneNumber'));
export const completeSetup = createAction(SecurityPhoneNumberActionTypes.COMPLETED_SETUP);
export const cancelSetup = createAction(SecurityPhoneNumberActionTypes.CANCELLED_SETUP);
export const confirmSetup = createAction(SecurityPhoneNumberActionTypes.CONFIRMED_SETUP);
export const configureSms = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS, mapPayloadTo('phoneNumber'));
export const configureSmsRequest = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_REQUEST, mapPayloadTo('phoneNumber'));
export const configureSmsSuccess = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS, mapPayloadTo('securityPhoneNumber'));
export const configureSmsFailure = createAction(SecurityPhoneNumberActionTypes.CONFIGURE_SMS_FAILURE, mapPayloadTo('error'));
export const resendCodeFailure = createAction(SecurityPhoneNumberActionTypes.RESEND_CODE_FAILURE, mapPayloadTo('error'));
export const changeCodeAttempt = createAction(SecurityPhoneNumberActionTypes.CHANGED_CODE_ATTEMPT, mapPayloadTo('codeAttempt'));
export const codeAttempt = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT, mapPayloadTo('codeAttempt'));
export const codeAttemptRequest = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_REQUEST);
export const codeAttemptSuccess = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS, mapPayloadTo('securityPhoneNumber'));
export const codeAttemptFailure = createAction(SecurityPhoneNumberActionTypes.CODE_ATTEMPT_FAILURE, mapPayloadTo('error'));